import {
  UserListingState,
  UserListingIndexedItem,
  CompanyActionTypes,
  COMPANY_LOAD_SUCCESS,
  UserFromResponse,
  ADD_USER_TO_LIST,
  MULTIPLE_USERS_SAVE_SUCCESS,
  CLEAR_2FA_SUCCESS,
  User,
  USER_DELETE_SUCCESS,
  USER_UPDATE_SUCCESS,
  GET_USERS_SUCCESS,
  Loader,
  GET_USERS_REQUEST,
} from 'src/store/types';

const loaderInitialState: Loader = {
  loading: false,
  success: false,
  error: '',
  completed: false,
};

const userListingInitialState: UserListingState = {
  users: {},
  totalItems: 0,
  loader: loaderInitialState,
};

const mapUsers = (users: UserFromResponse[]) => {
  return users.reduce(
    (list: UserListingIndexedItem, user: UserFromResponse) => {
      const { id, interviews, trainingType, ...restData } = user;
      const interviewIds = interviews ? interviews.map((i) => i.id) : [];
      return {
        ...list,
        [id]: {
          id,
          interviewIds,
          trainingType,
          trainingTypeId: trainingType?.id,
          ...restData,
        },
      };
    },
    {},
  );
};

export const userListingReducer = (
  state = userListingInitialState,
  action: CompanyActionTypes,
): UserListingState => {
  switch (action.type) {
    case COMPANY_LOAD_SUCCESS: {
      const { users } = action.company;
      return {
        users: mapUsers(users),
        totalItems: state.totalItems,
        loader: { ...loaderInitialState, completed: true, loading: false },
      };
    }
    case ADD_USER_TO_LIST: {
      const { id, name, email, avatarImg, role } = action.user;
      const interviewIds = action.user.interviews
        ? action.user.interviews.map((i: any) => i.id)
        : [];
      return {
        users: {
          ...state.users,
          [id]: { id, name, email, avatarImg, interviewIds, role },
        },
        totalItems: state.totalItems,
        loader: { ...loaderInitialState, completed: true, loading: false },
      };
    }
    case MULTIPLE_USERS_SAVE_SUCCESS: {
      const { users } = action;
      return {
        users: {
          ...state.users,
          ...mapUsers(users),
        },
        totalItems: state.totalItems,
        loader: { ...loaderInitialState, completed: true, loading: false },
      };
    }
    case CLEAR_2FA_SUCCESS: {
      const { userId } = action;

      const updatedUser: User | undefined = state.users[userId]
        ? { ...state.users[userId], isTwoFactorAuthenticationEnabled: false }
        : undefined;

      const updatedUsersMap = updatedUser
        ? { ...state.users, [userId]: updatedUser }
        : { ...state.users };

      return {
        users: updatedUsersMap,
        totalItems: state.totalItems,
        loader: { ...loaderInitialState, completed: true, loading: false },
      };
    }
    case USER_DELETE_SUCCESS: {
      const updatedUserListing = { ...state.users };
      delete updatedUserListing[action.id];
      return {
        users: updatedUserListing,
        totalItems: state.totalItems,
        loader: { ...loaderInitialState, completed: true, loading: false },
      };
    }
    case USER_UPDATE_SUCCESS: {
      const updatedUser: User | undefined = state.users[action.user.id]
        ? { ...state.users[action.user.id], ...action.user }
        : action.user;

      const updatedUsersMap = {
        ...state.users,
        [action.user.id]: updatedUser,
      };

      return {
        users: updatedUsersMap,
        totalItems: state.totalItems,
        loader: { ...loaderInitialState, completed: true, loading: false },
      };
    }
    case GET_USERS_SUCCESS: {
      const { users } = action;
      return {
        users: mapUsers(users.records),
        totalItems: users.total,
        loader: { ...loaderInitialState, completed: true, loading: false },
      };
    }
    case GET_USERS_REQUEST: {
      return {
        ...state,
        loader: { ...loaderInitialState, loading: true },
      };
    }
    default:
      return state;
  }
};
